import { useState } from "react";

/**
 * §5.B — RÈGLE ABSOLUE : un montant est un `input type="text"`, JAMAIS `number`.
 *
 * Les flèches du spinner incrémentaient à 1 au moindre clic : origine réelle de
 * montants à 1 F chez un client, montants d'origine DÉFINITIVEMENT PERDUS.
 *
 * De plus, tout montant strictement compris entre 0 et 100 F non confirmé est
 * marqué « ERREUR PROBABLE ». Deux issues, et le système n'en a AUCUNE :
 * le client corrige, ou il confirme explicitement. On signale, on ne corrige
 * jamais.
 */
export function ChampMontant({
  valeur,
  onChange,
  confirme,
  onConfirmer,
  label,
}: {
  valeur: string;
  onChange: (v: string) => void;
  confirme: boolean;
  onConfirmer: () => void;
  label: string;
}) {
  const [touche, setTouche] = useState(false);

  const nombre = Number(valeur.replace(/[^\d.,-]/g, "").replace(",", "."));
  const invraisemblable = Number.isFinite(nombre) && nombre > 0 && nombre < 100 && !confirme;

  return (
    <div className="champ-montant">
      <label>
        {label}
        <input
          // type="text" — voir le commentaire ci-dessus. Ne pas « corriger » en number.
          type="text"
          inputMode="decimal"
          value={valeur}
          onChange={(e) => {
            onChange(e.target.value);
            setTouche(true);
          }}
          aria-invalid={invraisemblable}
          aria-describedby={invraisemblable ? "montant-alerte" : undefined}
        />
      </label>

      {invraisemblable && (
        <div id="montant-alerte" className="alerte alerte--montant" role="alert">
          <strong>ERREUR PROBABLE</strong> — un montant de {nombre} F est inhabituel.
          Corrigez la saisie, ou confirmez :
          <button type="button" onClick={onConfirmer}>
            C'est bien le montant de la facture
          </button>
        </div>
      )}

      {confirme && touche && (
        <p className="note">
          La confirmation tombe dès que le montant change : un accord donné sur
          un montant ne couvre pas un autre montant.
        </p>
      )}
    </div>
  );
}
